let monacoEditor;
/**
 * Get the Monaco editor module
 *
 * @returns The Monaco editor module
 */
export function getMonaco() {
    if (!monacoEditor) {
        throw new Error('Monaco is undefined. Call setMonaco(monaco) first.');
    }
    return monacoEditor;
}
/**
 * Set the Monaco editor module to use.
 *
 * @param monaco The Monaco editor module
 */
export function setMonaco(monaco) {
    monacoEditor = monaco;
}
